function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 7.66667H1M11.8333 1V4.33333M5.16667 1V4.33333M5 17.6667H12C13.4001 17.6667 14.1002 17.6667 14.635 17.3942C15.1054 17.1545 15.4878 16.772 15.7275 16.3016C16 15.7669 16 15.0668 16 13.6667V6.66667C16 5.26654 16 4.56647 15.7275 4.03169C15.4878 3.56129 15.1054 3.17883 14.635 2.93915C14.1002 2.66667 13.4001 2.66667 12 2.66667H5C3.59987 2.66667 2.8998 2.66667 2.36502 2.93915C1.89462 3.17883 1.51217 3.56129 1.27248 4.03169C1 4.56647 1 5.26654 1 6.66667V13.6667C1 15.0668 1 15.7669 1.27248 16.3016C1.51217 16.772 1.89462 17.1545 2.36502 17.3942C2.8998 17.6667 3.59987 17.6667 5 17.6667Z",
  stroke: "#98989A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCampaignCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      aspectRatio: "1 / 1",
      width: 20,
      height: 20
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignCalendar);
export default __webpack_public_path__ + "static/media/campaign-calendar.7697fcd4.svg";
export { ForwardRef as ReactComponent };